export const makeResetMultiFactorDTO = () => ({});
